// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────
   Shared 3-column browse layout, used by every browse page: the Node, Data,
   Agent, Discovery and Model Catalogs, and the project list (which imports the
   rail, header band and drawer from here and adds only its own card styles in
   pages/projects/ProjectsBrowseLayout.module.css). The rail is CatalogRail.tsx
   and the header band CatalogPageHeader.tsx, so the pages cannot drift apart.

   Colours, type and geometry come from ../../styles/curioTokens.css. Format
   and category colours in particular are tokens, not literals: they are shown
   on six other surfaces and used to be copied into each of them.
   Page shell lives in CatalogMasterPage.module.css.
   ───────────────────────────────────────────────────────────── */

/* ── 3-column browse layout ── */
.VfrM6ibRZBlZ6gUG_Wk7 {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 188px minmax(0, 1fr) 0px;
  grid-template-rows: minmax(0, 1fr);
  /* Shared browse cards (every browse page; inherited by nested cards). A card
     is as tall as its content and a row as tall as its tallest card: the old
     268px floor left a band of blank card under every short description. */
  --catalogBrowseCardMinWidth: 220px;
  --catalogBrowseCardGridGap: 16px;
  --catalogBrowseCardGridPadding: 16px;
  --catalogBrowseCardBodyPadX: 16px;
  --catalogBrowseCardBodyPadBottom: 8px;
  --catalogBrowseCardDescLineHeight: 1.4;
  --catalogBrowseCardDescLines: 2;
  --catalogBrowseCardActionsMinH: 44px;
  --catalogBrowseCardActionsPadY: 8px;
  --catalogBrowseCardMetaPadTop: 10px;
  --catalogBrowseCardTagGap: 5px;
  /* Card grid scrollbar (Data + Nodes tabs) */
  --catalogBrowseCardGridScrollbarThumb: rgba(30, 31, 35, 0.22);
  --catalogBrowseCardGridScrollbarThumbHover: rgba(30, 31, 35, 0.35);
  --catalogBrowseCardGridScrollbarTrack: rgba(30, 31, 35, 0.06);
}

.nWJscCJ5p2UtOWtglln8 {
  grid-template-columns: 188px minmax(0, 1fr) 320px;
}

.L5BFXgCV9YdcpwokRYr7 {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* ══════════════════════════════════════════
   LEFT CATEGORY RAIL
   ══════════════════════════════════════════ */
.RpSSE68p5ogT1pcKgl0g {
  grid-column: 1;
  grid-row: 1;
  background: var(--curio-card-bg);
  border-right: 1px solid var(--curio-border);
  display: flex;
  flex-direction: column;
  padding: 8px 0 16px;
  overflow-y: auto;
}

/* Nothing in the rail may shrink. It is a flex column that scrolls, so when it
   is taller than the window the browser shrinks every child that allows it,
   and an empty 1px divider allows it down to nothing: the section lines showed
   on a rail that fit (Node, Agent, Data Lake) and vanished on one that did not
   (Data, Projects). */
.RpSSE68p5ogT1pcKgl0g > * {
  flex-shrink: 0;
}

.X1gaB7xlXqlJvrKuJjp5 {
  margin: 10px 0 4px;
  padding: 0 16px;
  font-size: 10px;
  font-weight: 700;
  color: #BBBBBB;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.nP9_T2b2FS7Sg1egdH8d {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 0;
  background: transparent;
  color: var(--curio-text-secondary);
  padding: 6px 16px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  text-align: left;
  min-height: 30px;
}

/* Hover feedback is for rows you have NOT chosen: the selected row already
   announces itself with its fill, its weight and its bar. */
.nP9_T2b2FS7Sg1egdH8d:hover:not(.AGy3WwvOXcyra3GV1JMn) { background: rgba(0,0,0,0.02); }

.AGy3WwvOXcyra3GV1JMn {
  background: var(--curio-page-bg);
  color: var(--curio-text-primary);
  font-weight: 700;
}

.AGy3WwvOXcyra3GV1JMn::before {
  content: "";
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 4px;
  background: var(--curio-top-bar-bg);
  border-radius: 0 2px 2px 0;
}

.VEVFUiIp0CTRM9tcM6eJ {
  min-width: 28px;
  height: 18px;
  border-radius: 9px;
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  flex-shrink: 0;
}

.mFyhwipkL21eRHE7xUwr {
  color: var(--curio-text-meta);
  font-size: 11px;
  flex-shrink: 0;
}

.mrN8fFdwyYFU3HWu89a0 {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.DBJUfSDi3zJ9Qmf_n4f2 {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.HQ3Imb8B5kCA9DgR545b { background: var(--curio-format-geojson-fg); }
.btLh58XW1qCPndVY2ovY { background: var(--curio-format-csv-fg); }
.JzyXx9YNRhK1_Bv261nT { background: var(--curio-format-json-fg); }
.JYZEu5i5KYcIouThIXPS { background: var(--curio-format-parquet-fg); }
.GUneDuGobBmHON6sBuaG { background: var(--curio-format-geotiff-fg); }
.xzonQ5DqNRSjLlK2ND8Q { background: var(--curio-format-shp-fg); }
.iBM1KWgO5udPBt6Jo1uv { background: var(--curio-format-bundle-fg); }
.O2L8ryJP41XbuoWu4gTw { background: var(--curio-format-osm-fg); }
.OeGz2VCUghGArMW6UJea { background: var(--curio-format-gpkg-fg); }
.cCRK06v6zAzCEYV0SLAw { background: var(--curio-format-gtfs-fg); }
.jVuT8ZjNUhucdJPaHgOd { background: var(--curio-format-collection-fg); }
.IIQV7kICx9k0nGhGx26G { background: var(--curio-format-onnx-fg); }
.gJFa9MXu1IaVD4wFHM4H { background: var(--curio-format-netcdf-fg); }

/* Node Catalog category rows: the same keys and colours as the package card
   strips (\`primaryCategory()\`: data | computation | vis | package). */
.QkqENvOMgp7hc9SaPPbM        { background: var(--curio-category-data-fg); }
.Igvz2umcHE_cRcKVf2Mq { background: var(--curio-category-computation-fg); }
.NcQLlzXiG7W9tTGCljnb         { background: var(--curio-category-vis-fg); }
.wkGnUazAVtm3myMrGcpG     { background: var(--curio-category-package-fg); }

/* Agent Catalog category rows: the agent card strips' palette keys
   (\`agentCategoryKey()\`), not the node categories. */
.YogVuZXZMhOY7ALQVyR3     { background: var(--curio-category-agent-node-fg); }
.r7THFCjoOTTSCb5jdory   { background: var(--curio-category-agent-canvas-fg); }
.l7byw8ovwwChEh0QoWLb     { background: var(--curio-category-agent-data-fg); }
.eqXcqnuiKJcWIH379mp9 { background: var(--curio-category-agent-evaluate-fg); }
.eACMCYfS1vAA_qVNwPFN  { background: var(--curio-category-agent-package-fg); }

.l26vAdNzKqlzonq6bO1C {
  height: 1px;
  margin: 10px 16px 0;
  background: #EBEBEB;
}

/* ══════════════════════════════════════════
   MAIN BROWSE AREA
   ══════════════════════════════════════════ */
/* The header stays put and the card grid owns the scroll, so the grid takes
   exactly the height the header leaves. It used to be sized as
   \`calc(100vh - 290px)\`, a guess at the header that was wrong as soon as an
   intro wrapped, and then the whole column scrolled as well. */
._m6dG9gLZ0nF9aODfwWu {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ── Page header (white): one row, then a one-line intro ── */
.IUsCLvHaiNyCRZeB26Io {
  background: var(--curio-card-bg);
  padding: 12px 20px 10px;
  border-bottom: 1px solid var(--curio-border);
  flex-shrink: 0;
}

.wRpK9B2nL0BgYHrEWHvI {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
}

.wRpK9B2nL0BgYHrEWHvI h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--curio-text-primary);
}

.ktMrB9OfRJpyTlKCOzJy {
  min-width: 34px;
  height: 22px;
  border-radius: 11px;
  background: #E8E8E5;
  color: #777777;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
}

/* The second header row: the intro, then sort (and Projects' grid or list
   switch) at its end, right above the cards they arrange. Sort sat in the chip
   row before; it moved here rather than into the title row, where the Projects
   page's three actions left it no room. */
.lqgq1gOBYDuHw6ts9hNs {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 6px;
}

/* Page description under the title row. Was an inline style duplicated
   verbatim in NodeCatalogBrowse and DataCatalogBrowse. */
.KQ18_kh6q4rJHMZr4Fh4 {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-size: var(--curio-font-size-sm);
  line-height: 1.4;
  color: var(--curio-text-secondary);
}

.SaZcifbeP1OADRCRp0zV {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

/* Search and the page's actions, at the end of the title row. It takes all
   the width the title leaves and never wraps: the search box gives up width
   instead, so the buttons stay on the title's line. */
.LEmprhZKDr0RbmzV4Y4L {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 8px;
}

._MnkjfhCufoYt1a7nngw {
  flex: 0 1 240px;
  min-width: 120px;
  max-width: 300px;
  height: 34px;
  border: 1px solid var(--curio-border);
  border-radius: 9px;
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  padding: 0 12px;
  font-family: inherit;
  font-size: 12px;
}

._MnkjfhCufoYt1a7nngw::placeholder { color: #CCCCCC; }
._MnkjfhCufoYt1a7nngw:focus { outline: none; border-color: #AAAAAA; }

.JsRq91dug7VMxP8bFMO8 {
  height: 34px;
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  background: transparent;
  color: var(--curio-text-primary);
  padding: 0 14px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.JsRq91dug7VMxP8bFMO8:hover { background: #f5f5f5; }

.DOoCTCnNbZPY8Lgcbaa_ {
  height: 34px;
  border: 0;
  border-radius: var(--curio-radius-lg);
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  padding: 0 16px;
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.DOoCTCnNbZPY8Lgcbaa_:hover { background: var(--curio-top-bar-bg-hover); }

/* ── Search bar ──
   Only the Data Lake source page has one now, above its results. The browse
   pages had a chip row here that repeated the rail beside it: the same "All",
   the same "In all projects", the same formats and categories. It cost every
   page 49 to 84px above the cards and is gone; its sort control lives in the
   header row. */
.HQZx0WKGk9aNKS2rCKpJ {
  background: #FAFAFA;
  border-bottom: 1px solid #E8E8E8;
  padding: 11px 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.DJPfPFYq7OyezuoSbeY2 { flex: 1; }

/* Bordered like the search box above it, a step lower so the intro row it
   shares stays one line of text tall. */
.Od_5CuSCyh5eEKYUL4fN {
  height: 28px;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-lg);
  background: var(--curio-card-bg);
  color: var(--curio-text-secondary);
  padding: 0 8px;
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
  flex-shrink: 0;
}

/* ── Card grid ──
   As many columns as fit, from the width the grid actually has: with the
   details drawer open at 1280px that is three, with it closed four. It was
   three fixed columns that fell to two below a 1300px VIEWPORT, whatever the
   rail and the drawer left of it. */
.fpRBOzsRnwrxKWXjMFdP {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--catalogBrowseCardMinWidth, 220px), 1fr));
  /* A row is as tall as its tallest card, never less. The cards clip their
     overflow, which gives them no automatic minimum height, so in a grid of
     fixed height (this one scrolls) \`auto\` rows would share that height out
     and crush every card to a strip and half a title. */
  grid-auto-rows: max-content;
  gap: var(--catalogBrowseCardGridGap, 16px);
  padding: var(--catalogBrowseCardGridPadding, 16px);
  /* Pack rows to the top so a short filtered list does not stretch rows to fill the viewport */
  align-content: start;
  align-items: stretch;
  box-sizing: border-box;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: var(--catalogBrowseCardGridScrollbarThumb, rgba(30, 31, 35, 0.22))
    var(--catalogBrowseCardGridScrollbarTrack, rgba(30, 31, 35, 0.06));
}

.jCLYRVsTDVwGLVOBlvVf {
  opacity: 0.72;
  pointer-events: none;
  transition: opacity 0.18s ease-out;
}

.fpRBOzsRnwrxKWXjMFdP::-webkit-scrollbar {
  width: 6px;
}

.fpRBOzsRnwrxKWXjMFdP::-webkit-scrollbar-track {
  background: var(--catalogBrowseCardGridScrollbarTrack, rgba(30, 31, 35, 0.06));
  border-radius: 3px;
  margin: 4px 0;
}

.fpRBOzsRnwrxKWXjMFdP::-webkit-scrollbar-thumb {
  background: var(--catalogBrowseCardGridScrollbarThumb, rgba(30, 31, 35, 0.22));
  border-radius: 3px;
  border: 1px solid transparent;
  background-clip: padding-box;
}

.fpRBOzsRnwrxKWXjMFdP::-webkit-scrollbar-thumb:hover {
  background: var(--catalogBrowseCardGridScrollbarThumbHover, rgba(30, 31, 35, 0.35));
  background-clip: padding-box;
}

.heWl2fugj3DzhjzWyNRf, .y8im69drSGaobhllQ895 {
  margin: 24px;
  border: 1px dashed #d4d3cd;
  border-radius: 8px;
  color: var(--curio-text-meta);
  padding: 32px 16px;
  text-align: center;
  font-size: 13px;
}

.y8im69drSGaobhllQ895 {
  color: var(--curio-danger-text);
  background: var(--curio-danger-bg);
  border-color: var(--curio-danger-border);
}

/* ══════════════════════════════════════════
   BROWSE CARD
   ══════════════════════════════════════════ */
.Ea9RFRvFcbDKactM5lkt {
  display: flex;
  flex-direction: column;
  border: 1.5px solid transparent;
  border-radius: 10px;
  background: var(--curio-card-bg);
  box-shadow: var(--curio-shadow-browse-card);
  overflow: hidden;
  cursor: pointer;
  outline: none;
  transition: box-shadow 0.15s, border-color 0.15s;
  box-sizing: border-box;
  height: auto;
  align-self: stretch;
}

.Ea9RFRvFcbDKactM5lkt:hover, .Ea9RFRvFcbDKactM5lkt:focus-visible {
  box-shadow: var(--curio-shadow-browse-card-raised);
}

.kCuH8CQkfSW9gXLWxhpw { box-shadow: var(--curio-shadow-browse-card-raised); }

/* Colored top strip */
.Oyt7UMsROFaVYI9VPHBf {
  min-height: 28px;
  display: flex;
  align-items: center;
  padding: 3px 12px;
  flex-shrink: 0;
}

.C80pwmK47C2xvCPw_m53 { background: var(--curio-format-geojson-fg); }
.wSl0TR_J46q2BQcJbbdw { background: var(--curio-format-csv-fg); }
.XfKxAyIiENuLxUnBOgpr { background: var(--curio-format-json-fg); }
.qneyw4mvDLnP2BmO4tM6 { background: var(--curio-format-parquet-fg); }
.quLmk_YNj2mI7pI80yjI { background: var(--curio-format-geotiff-fg); }
.wA1qF13_Of68phDsUmRA { background: var(--curio-format-shp-fg); }
.jDiM_vjXEcHRBVHr0MQN { background: var(--curio-format-bundle-fg); }
.FnfWTXsNV_24MnmPsKJi { background: var(--curio-format-osm-fg); }
.cp6x1w8eusHmJbcMwwgr { background: var(--curio-format-gpkg-fg); }
.j4rjCmNJnYJUJVAvQ8AP { background: var(--curio-format-gtfs-fg); }
.pka4q2YQo_ymKNks3vt_ { background: var(--curio-format-collection-fg); }
.irdO111llFcptmniJVbg { background: var(--curio-format-onnx-fg); }
.zCKkKH2PNMaggCe66HxW { background: var(--curio-format-netcdf-fg); }

/* Active card: colored border matches strip */
.kCuH8CQkfSW9gXLWxhpw.u6V2C3nrzhUeU7thtAmW { border-color: var(--curio-format-geojson-fg); }
.kCuH8CQkfSW9gXLWxhpw.oBQoWjgFZEzBIkfC6BV2 { border-color: var(--curio-format-csv-fg); }
.kCuH8CQkfSW9gXLWxhpw.ppTeP0YXzYojAHBi_spx { border-color: var(--curio-format-json-fg); }
.kCuH8CQkfSW9gXLWxhpw.AyxStruIbyNkyilqFHAv { border-color: var(--curio-format-parquet-fg); }
.kCuH8CQkfSW9gXLWxhpw.bOxQR9KCCz3DecduXZHV { border-color: var(--curio-format-geotiff-fg); }
.kCuH8CQkfSW9gXLWxhpw.L7pl144ncELLiafzUfOB { border-color: var(--curio-format-shp-fg); }
.kCuH8CQkfSW9gXLWxhpw.eAc5Es49mUImW9VuwbgY { border-color: var(--curio-format-bundle-fg); }
.kCuH8CQkfSW9gXLWxhpw.xylyk_B9dSDNKfXUcwWt { border-color: var(--curio-format-osm-fg); }
.kCuH8CQkfSW9gXLWxhpw.zsDyFMQRPkt9yoPiwnGE { border-color: var(--curio-format-gpkg-fg); }
.kCuH8CQkfSW9gXLWxhpw.RCWdbUXjTOZUWL0eH25y { border-color: var(--curio-format-gtfs-fg); }
.kCuH8CQkfSW9gXLWxhpw._8QkDYruqlnHGDmZ5LpD { border-color: var(--curio-format-collection-fg); }
.kCuH8CQkfSW9gXLWxhpw.UYOLRIBFsDcCNnb_dzOa { border-color: var(--curio-format-onnx-fg); }
.kCuH8CQkfSW9gXLWxhpw.VKQYxN8g3fp0mXzogoS7 { border-color: var(--curio-format-netcdf-fg); }

.i21Tmvmsm6NrSB8p1Xq5 {
  height: 16px;
  border-radius: 8px;
  background: rgba(255,255,255,0.22);
  color: var(--curio-text-on-dark);
  padding: 0 8px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  display: inline-flex;
  align-items: center;
}

.UwqrsEueCeHwvHLFDped {
  height: 16px;
  border-radius: 8px;
  background: rgba(255,255,255,0.22);
  color: var(--curio-text-on-dark);
  padding: 0 8px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
}

/* Card body */
.HiGL2UaWpfWgbILZoGsP {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 0 var(--catalogBrowseCardBodyPadX, 16px) var(--catalogBrowseCardBodyPadBottom, 8px);
}

.g0SyRaaABSoynYeHBV1w {
  margin: 10px 0 2px;
  font-size: 13px;
  font-weight: 700;
  color: var(--curio-text-primary);
  line-height: 1.3;
}

.iCiyQIr00Nx2MpMzsif8 {
  margin: 0;
  font-size: 11px;
  color: var(--curio-text-meta);
}

.ZI_RVyVfqVoobMHdLwfc {
  margin: 8px 0 0;
  font-size: 13px;
  color: var(--curio-text-primary);
  line-height: var(--catalogBrowseCardDescLineHeight, 1.4);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: calc(var(--catalogBrowseCardDescLines, 2) * var(--catalogBrowseCardDescLineHeight, 1.4) * 1em);
  flex-shrink: 0;
}

.bsGpXtnYtJvag8qSQvDk {
  display: flex;
  flex-wrap: wrap;
  gap: var(--catalogBrowseCardTagGap, 5px);
  margin: 0;
  margin-top: auto;
  padding-top: 10px;
  min-height: 22px;
  align-content: flex-end;
}

.YEpMi4BN6Fs0v9KImgt2 {
  height: 16px;
  border-radius: 8px;
  background: var(--curio-page-bg);
  color: var(--curio-text-secondary);
  padding: 0 7px;
  font-size: 9px;
  display: inline-flex;
  align-items: center;
}

/* Meta row */
.gWuUm7jra6fYsT8NVmWD {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin: 0;
  margin-top: 4px;
  padding: var(--catalogBrowseCardMetaPadTop, 10px) var(--catalogBrowseCardBodyPadX, 16px) 0;
  border-top: 1px solid var(--curio-page-bg);
  font-size: 10px;
  color: var(--curio-text-meta);
  flex-shrink: 0;
}

.QwsmAXVqGTmlj4KLSeHc {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.VEoANzs40k0cUUD1G_yZ {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  font-size: 11px;
}

.uVCBcIpS7SwSRd9oui9u {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.Eksaf8kloYVG6HTtCr7w { background: var(--curio-role-installed-fg); }
.lWqXFU0tN3FlHvf5TwhY  { background: var(--curio-text-muted); }

/* Actions row */
.EcJpkKqEkAF7Y6jqGBon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0;
  min-height: var(--catalogBrowseCardActionsMinH, 44px);
  padding: var(--catalogBrowseCardActionsPadY, 8px) var(--catalogBrowseCardBodyPadX, 16px) 10px;
  border-top: 1px solid var(--curio-page-bg);
  flex-shrink: 0;
  box-sizing: border-box;
}

.EfEOld4D0B6ONZiYbOX4 {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

/* A card's state ("In all projects", "Link only"), at the start of its
   actions row: the strip says what the item is, this says where it stands,
   the link beside it says what you can do. It rode at the end of the strip
   until the cards narrowed, where it ran over the format or category pill. */
.cxRf8OFnyHqkRd11tWyh {
  font-size: 11px;
  font-weight: 600;
  color: var(--curio-role-installed-fg);
  white-space: nowrap;
}

.q_mzL6TdHxuauM3jTaAd {
  color: var(--curio-text-meta);
}

.Udy_6MnAqN8dQaRo2bay {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.BT9AXwP321l29GBQSXCP {
  border: 0;
  background: transparent;
  padding: 0;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  color: var(--curio-text-primary);
  cursor: pointer;
}

.BT9AXwP321l29GBQSXCP:hover {
  text-decoration: underline;
}

/* A drawer CTA that is neither an action nor a destructive one.
 *
 * The catalogs run a strict two-colour vocabulary: dark filled = action, light
 * bordered = destructive. "View details" is neither - it navigates - so giving
 * it either treatment would say something false about it. It keeps the CTA
 * stack's 42px height so the column does not go ragged, and reads as the link
 * it is. Same role as \`.linkButton\` on the cards, sized for the drawer.
 */
.LjnSjQTrL34E9Cih80MZ {
  width: 100%;
  height: 42px;
  border: 0;
  background: transparent;
  padding: 0;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: var(--curio-text-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.LjnSjQTrL34E9Cih80MZ:hover {
  text-decoration: underline;
}

/* ══════════════════════════════════════════
   RIGHT DETAIL DRAWER
   ══════════════════════════════════════════ */
/* Grid cell that clips the sliding drawer as the column expands / collapses. */
.eD7RmaJ0uK8QbFctDqeT {
  grid-column: 3;
  grid-row: 1;
  min-width: 0;
  overflow: hidden;
  position: relative;
}

/* Entire drawer panel — appears and disappears with its column, no motion. */
.HRysVvXtLohrQPQNqn4s {
  width: 320px;
  height: 100%;
  background: var(--curio-card-bg);
  border-left: 1px solid var(--curio-border);
  box-shadow: -4px 0 10px rgba(0,0,0,0.09);
  display: flex;
  flex-direction: column;
  /* The body scrolls, not the drawer: the header and the action row stay
     where they are (#526). */
  overflow: hidden;
}

.js4kV40F7vPQXURE8zA_ {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.pmlkfSWrL0UNYPZRa1dw {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 50px;
  background: #FAFAFA;
  border-bottom: 1px solid #EBEBEB;
  padding: 0 20px;
  flex-shrink: 0;
}

/* Dismissible banner above the card grid: an action error, or a summary of
   what an install just did. NodeCatalogBrowse still writes this with inline
   styles - two of them, in two hardcoded colour pairs - which is exactly the
   drift the token palette exists to end. Declared here so every browse page
   can share one, and so the colours come from tokens. */
.UB9_82UlKA2RTp9gzQ1X {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 12px 24px 0;
    padding: 10px 14px;
    border: 1px solid var(--curio-danger-border);
    border-radius: var(--curio-radius-md);
    background: var(--curio-danger-bg);
    color: var(--curio-danger-text);
    font-family: var(--curio-font-family);
    font-size: var(--curio-font-size-md);
}

.HkcciIErtLIJudh1atK5 {
    flex-shrink: 0;
    background: none;
    border: none;
    color: inherit;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    padding: 0 4px;
}

.BqG0Y0aEje2A2A9spxLA {
  margin: 16px 20px 0;
  height: 112px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6f8;
  flex-shrink: 0;
}

.Z4oTMuV7ll4bKCNwILgN {
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: #AAAAAA;
  font-size: 18px;
  line-height: 1;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Geo preview */
.J1upoyYEre9lke7jz3Ug {
  margin: 16px 20px 0;
  height: 112px;
  border-radius: 8px;
  background: #F0FAF2;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.lPYIDo7yfqERzPDgShZl {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.eoseNlalhE_VkJ0JQA7T {
  position: relative;
  z-index: 1;
  font-size: 10px;
  color: #666666;
  padding: 0 12px 8px;
  text-align: center;
}

.pWv_QrAWZ_U6jFrKGbND {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.94);
  padding: 6px 8px;
  box-sizing: border-box;
}

.mLqg67fWPyJBFuXEvWNw {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 9px;
  line-height: 1.25;
}

.mLqg67fWPyJBFuXEvWNw th,
.mLqg67fWPyJBFuXEvWNw td {
  padding: 2px 4px;
  border-bottom: 1px solid #ebebeb;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.mLqg67fWPyJBFuXEvWNw th {
  color: var(--curio-text-meta);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.mLqg67fWPyJBFuXEvWNw td {
  color: #333333;
}

/* Dataset name */
.NpSy3vgaqYVibH3GbiFh {
  padding: 14px 20px 0;
  flex-shrink: 0;
}

.NpSy3vgaqYVibH3GbiFh h2 {
  margin: 0 0 10px;
  font-size: 17px;
  font-weight: 700;
  color: var(--curio-text-primary);
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.z8DwWu3kbZg8Pln7Ss_H {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.DSNEy60md2A0cs0wiWab {
  height: 20px;
  border-radius: 10px;
  padding: 0 10px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  display: inline-flex;
  align-items: center;
}

.ERYh1vZy6cU_sE2Y3jmn { background: var(--curio-format-geojson-bg); color: var(--curio-format-geojson-on-tint); }
.faIAFdoaFfw7CMKlezFf { background: var(--curio-format-csv-bg); color: var(--curio-format-csv-on-tint); }
.w63G4ZLcmAu2X1PzF5nl { background: var(--curio-format-json-bg); color: var(--curio-format-json-on-tint); }
.M5vvez9PhKdTj0ZfrGY0 { background: var(--curio-format-parquet-bg); color: var(--curio-format-parquet-on-tint); }
.BGRw79y69hgWZtywyyXT { background: var(--curio-format-geotiff-bg); color: var(--curio-format-geotiff-on-tint); }
.mOxlOtKiNEaENGlucFxh { background: var(--curio-format-shp-bg); color: var(--curio-format-shp-on-tint); }
.EBZ_iySwSjYIpjXHQL1A { background: var(--curio-format-bundle-bg); color: var(--curio-format-bundle-on-tint); }
.rTDWATkJ6eQGQYBsSADG { background: var(--curio-format-osm-bg); color: var(--curio-format-osm-on-tint); }
.fH4Edy9K4VreYdlF1rmo { background: var(--curio-format-gpkg-bg); color: var(--curio-format-gpkg-on-tint); }
.wXTuZ1AG6ditVa9O0AlA { background: var(--curio-format-gtfs-bg); color: var(--curio-format-gtfs-on-tint); }
.fvnFq4jLze0Hlb8dRQX6 { background: var(--curio-format-collection-bg); color: var(--curio-format-collection-on-tint); }
.MLwwcI40hYRIppEEeXY6 { background: var(--curio-format-onnx-bg); color: var(--curio-format-onnx-on-tint); }
.lHcIlCZg0Xnf_VGYLz5v { background: var(--curio-format-netcdf-bg); color: var(--curio-format-netcdf-on-tint); }

.lBjXlfgXiCyqDqSPLdxw {
  height: 20px;
  border-radius: 10px;
  background: var(--curio-role-installed-bg);
  color: var(--curio-role-installed-fg);
  padding: 0 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* Package category pill. Distinct from .drawerFormatBadge: a category is not a
   file format, so it must not borrow a dfmt_* colour (the package drawer used to
   render its category in the parquet orange). */
.c8FRRRPBL79WB8t1qCcz {
  height: 20px;
  border-radius: 10px;
  background: var(--curio-surface-muted);
  color: var(--curio-text-primary);
  padding: 0 10px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  display: inline-flex;
  align-items: center;
}

/* Publisher row */
.bwxsqm3wz1XHPX__W5_a {
  padding: 0 20px 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.NPVYWaNMjWErEd61DJAd {
  font-size: 11px;
  font-weight: 600;
  color: var(--curio-text-secondary);
}

/* Usage meta */
.kjPETWEmQJ9qsY0WqkRR {
  padding: 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  color: var(--curio-text-meta);
  margin-bottom: 0;
  flex-shrink: 0;
}

.jgSQ7fZ7QKzTLPUllAfJ {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}

/* Section blocks */
.z3ODzfMh06ZMDSW34Kz9 {
  border-top: 1px solid #F2F2F2;
  padding: 12px 20px;
  flex-shrink: 0;
}

.JX_sWW3iIlyjommLo4yr {
  margin: 0 0 10px;
  font-size: 10px;
  font-weight: 700;
  color: #BBBBBB;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.Sj5U_1RMBn0yf1wObUKF {
  margin: 0;
  font-size: 13px;
  color: var(--curio-text-primary);
  line-height: 1.5;
}

/* Info table rows */
.JclYPmrHJHtwGYb0bqbJ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 26px;
  border-bottom: 1px solid #F8F8F8;
  font-size: 11px;
}

.JclYPmrHJHtwGYb0bqbJ:last-child { border-bottom: 0; }

.rfz9uAZ_tskHdo0dhwBs {
  color: var(--curio-text-primary);
  font-weight: 600;
}

.t3T763SxGWHEmgSJO8uY {
  color: var(--curio-text-meta);
}

/* Bulleted list inside a drawer section (e.g. "Nodes in pack"). */
.Zg1DmXE5Map38Kx8Pv99 {
  margin: 0;
  padding-left: 18px;
  font-size: 12px;
  color: var(--curio-text-secondary);
}

.pHXpBeB3OJ6oDl_M4aHO {
  color: var(--curio-text-muted);
}

/* Tags in drawer */
.gn3JbMteJP5Y_4j0FbcR {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.I2ZgBDYtbP4BxauGthpv {
  height: 20px;
  border-radius: 10px;
  background: var(--curio-page-bg);
  color: var(--curio-text-secondary);
  padding: 0 10px;
  font-size: 10px;
  display: inline-flex;
  align-items: center;
}

/* CTA section */
.Dm2nkDu8PT9KqFVGDFbT {
  border-top: 1px solid #EBEBEB;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
}

.uQSm8qRDfWccp_QT5sdF {
  width: 100%;
  height: 42px;
  border: 0;
  border-radius: 8px;
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.uQSm8qRDfWccp_QT5sdF:hover { background: var(--curio-top-bar-bg-hover); }

/* The destructive twin of \`.addToPaletteBtn\`, same box so the panel does not
 * reflow when a card swaps one for the other.
 *
 * One vocabulary across every catalog surface: dark is an action, light with a
 * border is destructive. The Agent browse drawer used \`.addToPaletteBtn\` for
 * BOTH "Add to my account" and "Remove from my account", so the two opposite
 * actions were the same black button in the same place, and the destructive one
 * carried the visual weight of the primary. */
.Vtj51SwFkMB1FGzKAplg {
  width: 100%;
  height: 42px;
  border: 1px solid var(--curio-border-strong);
  border-radius: 8px;
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.Vtj51SwFkMB1FGzKAplg:hover:not(:disabled) {
  border-color: #888787;
  background: var(--curio-page-bg);
}

.Vtj51SwFkMB1FGzKAplg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pUuRE8tStgOUaJJXSmKO {
  display: flex;
  justify-content: center;
}

/* A centred note standing in for the primary action, when there is no action
   left to offer - a package already in your defaults, a portal that cannot be
   searched. Shared because both of those pages wanted it and one of them was
   reaching for an inline \`textAlign: center\` to get it. */
.oHCrVYWGHuEySWd1ji_R {
  margin: 0;
  text-align: center;
  font-size: var(--curio-font-size-md);
  color: var(--curio-text-secondary);
  line-height: 1.5;
}

/* ══════════════════════════════════════════
   RESPONSIVE
   ══════════════════════════════════════════ */
/* No column counts here: the grid's auto-fill already follows the width it
   has. These only move the drawer and the rail out of the way. */
@media (max-width: 1100px) {
  .VfrM6ibRZBlZ6gUG_Wk7 { grid-template-columns: 188px minmax(0, 1fr); }
  .eD7RmaJ0uK8QbFctDqeT { display: none; }
  .LEmprhZKDr0RbmzV4Y4L { flex-wrap: wrap; }
}

/* One column of everything, and the page scrolls as a whole: the rail sits
   above the header, so neither region has a height of its own to scroll in. */
@media (max-width: 820px) {
  .VfrM6ibRZBlZ6gUG_Wk7 { display: block; overflow-y: auto; }
  .RpSSE68p5ogT1pcKgl0g { border-right: 0; border-bottom: 1px solid var(--curio-border); }
  ._m6dG9gLZ0nF9aODfwWu { overflow: visible; }
  .fpRBOzsRnwrxKWXjMFdP { overflow: visible; }
  .LEmprhZKDr0RbmzV4Y4L { flex: 1 1 100%; justify-content: flex-start; }
  ._MnkjfhCufoYt1a7nngw { max-width: none; flex: 1 1 100%; }
}

`, "",{"version":3,"sources":["webpack://./src/pages/catalog/CatalogBrowseLayout.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;kEAWkE;;AAElE,iCAAiC;AACjC;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,+CAA+C;EAC/C,kCAAkC;EAClC;;2EAEyE;EACzE,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;EACpC,iCAAiC;EACjC,qCAAqC;EACrC,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,8BAA8B;EAC9B,4CAA4C;EAC5C,6DAA6D;EAC7D,kEAAkE;EAClE,6DAA6D;AAC/D;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;;+CAE+C;AAC/C;EACE,cAAc;EACd,WAAW;EACX,gCAAgC;EAChC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;sBAIsB;AACtB;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;4DAC4D;AAC5D,yDAA2C,4BAA4B,EAAE;;AAEzE;EACE,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,MAAM,EAAE,SAAS;EAC1B,UAAU;EACV,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,wBAAe,0CAA0C,EAAE;AAC3D,wBAAW,sCAAsC,EAAE;AACnD,wBAAY,uCAAuC,EAAE;AACrD,wBAAe,0CAA0C,EAAE;AAC3D,wBAAe,0CAA0C,EAAE;AAC3D,wBAAW,sCAAsC,EAAE;AACnD,wBAAc,yCAAyC,EAAE;AACzD,wBAAW,sCAAsC,EAAE;AACnD,wBAAY,uCAAuC,EAAE;AACrD,wBAAY,uCAAuC,EAAE;AACrD,wBAAkB,6CAA6C,EAAE;AACjE,wBAAY,uCAAuC,EAAE;AACrD,wBAAc,yCAAyC,EAAE;;AAEzD;sEACsE;AACtE,+BAA2B,yCAAyC,EAAE;AACtE,wBAA2B,gDAAgD,EAAE;AAC7E,gCAA2B,wCAAwC,EAAE;AACrE,4BAA2B,4CAA4C,EAAE;;AAEzE;qDACqD;AACrD,4BAAqB,+CAA+C,EAAE;AACtE,0BAAqB,iDAAiD,EAAE;AACxE,4BAAqB,+CAA+C,EAAE;AACtE,wBAAqB,mDAAmD,EAAE;AAC1E,yBAAqB,kDAAkD,EAAE;;AAEzE;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;+CAE+C;AAC/C;;;+DAG+D;AAC/D;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,gCAAgC;EAChC,uBAAuB;EACvB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;0CAG0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;yDACyD;AACzD;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;sDAEsD;AACtD;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA,qCAA0B,cAAc,EAAE;AAC1C,8BAAmB,aAAa,EAAE,qBAAqB,EAAE;;AAEzD;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8BAAuB,mBAAmB,EAAE;;AAE5C;EACE,YAAY;EACZ,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8BAA6B,yCAAyC,EAAE;;AAExE;;;;;gBAKgB;AAChB;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAgB,OAAO,EAAE;;AAEzB;wCACwC;AACxC;EACE,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;;;oCAIoC;AACpC;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,8FAA8F;EAC9F;;;wDAGsD;EACtD,2BAA2B;EAC3B,0CAA0C;EAC1C,kDAAkD;EAClD,6FAA6F;EAC7F,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB;sEACoE;AACtE;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8EAA8E;EAC9E,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,8EAA8E;EAC9E,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mFAAmF;EACnF,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,gCAAgC;EAChC,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gDAAgD;EAChD,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;AACpD;;AAEA,wBAAc,kDAAkD,EAAE;;AAElE,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wBAAiB,0CAA0C,EAAE;AAC7D,wBAAa,sCAAsC,EAAE;AACrD,wBAAc,uCAAuC,EAAE;AACvD,wBAAiB,0CAA0C,EAAE;AAC7D,wBAAiB,0CAA0C,EAAE;AAC7D,wBAAa,sCAAsC,EAAE;AACrD,wBAAgB,yCAAyC,EAAE;AAC3D,wBAAa,sCAAsC,EAAE;AACrD,wBAAc,uCAAuC,EAAE;AACvD,wBAAc,uCAAuC,EAAE;AACvD,wBAAoB,6CAA6C,EAAE;AACnE,wBAAc,uCAAuC,EAAE;AACvD,wBAAgB,yCAAyC,EAAE;;AAE3D,8CAA8C;AAC9C,6CAA2B,4CAA4C,EAAE;AACzE,6CAAuB,wCAAwC,EAAE;AACjE,6CAAwB,yCAAyC,EAAE;AACnE,6CAA2B,4CAA4C,EAAE;AACzE,6CAA2B,4CAA4C,EAAE;AACzE,6CAAuB,wCAAwC,EAAE;AACjE,6CAA0B,2CAA2C,EAAE;AACvE,6CAAuB,wCAAwC,EAAE;AACjE,6CAAwB,yCAAyC,EAAE;AACnE,6CAAwB,yCAAyC,EAAE;AACnE,6CAA8B,+CAA+C,EAAE;AAC/E,6CAAwB,yCAAyC,EAAE;AACnE,6CAA0B,2CAA2C,EAAE;;AAEvE;EACE,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;EAChC,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,4FAA4F;AAC9F;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,wDAAwD;EACxD,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,0GAA0G;EAC1G,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wCAAwC;EACxC,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;EAClC,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,SAAS;EACT,eAAe;EACf,0FAA0F;EAC1F,0CAA0C;EAC1C,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,wBAAgB,0CAA0C,EAAE;AAC5D,yBAAgB,mCAAmC,EAAE;;AAErD,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,qDAAqD;EACrD,6FAA6F;EAC7F,0CAA0C;EAC1C,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;;;6EAG6E;AAC7E;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;EAOE;AACF;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;+CAE+C;AAC/C,+EAA+E;AAC/E;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,6EAA6E;AAC7E;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,0CAA0C;EAC1C,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB;6BAC2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;;;;wDAIwD;AACxD;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,qCAAqC;IACrC,kCAAkC;IAClC,+BAA+B;IAC/B,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,wBAAgB,0CAA0C,EAAE,0CAA0C,EAAE;AACxG,wBAAY,sCAAsC,EAAE,sCAAsC,EAAE;AAC5F,wBAAa,uCAAuC,EAAE,uCAAuC,EAAE;AAC/F,wBAAgB,0CAA0C,EAAE,0CAA0C,EAAE;AACxG,wBAAgB,0CAA0C,EAAE,0CAA0C,EAAE;AACxG,wBAAY,sCAAsC,EAAE,sCAAsC,EAAE;AAC5F,wBAAe,yCAAyC,EAAE,yCAAyC,EAAE;AACrG,wBAAY,sCAAsC,EAAE,sCAAsC,EAAE;AAC5F,wBAAa,uCAAuC,EAAE,uCAAuC,EAAE;AAC/F,wBAAa,uCAAuC,EAAE,uCAAuC,EAAE;AAC/F,wBAAmB,6CAA6C,EAAE,6CAA6C,EAAE;AACjH,wBAAa,uCAAuC,EAAE,uCAAuC,EAAE;AAC/F,wBAAe,yCAAyC,EAAE,yCAAyC,EAAE;;AAErG;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;gDAEgD;AAChD;EACE,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA,mCAAsB,gBAAgB,EAAE;;AAExC;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kEAAkE;AAClE;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,8BAAyB,yCAAyC,EAAE;;AAEpE;;;;;;;8CAO8C;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;0DAG0D;AAC1D;EACE,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;+CAE+C;AAC/C;iEACiE;AACjE;EACE,wBAAQ,2CAA2C,EAAE;EACrD,wBAAsB,aAAa,EAAE;EACrC,wBAAe,eAAe,EAAE;AAClC;;AAEA;8EAC8E;AAC9E;EACE,wBAAQ,cAAc,EAAE,gBAAgB,EAAE;EAC1C,wBAAgB,eAAe,EAAE,4CAA4C,EAAE;EAC/E,wBAAc,iBAAiB,EAAE;EACjC,wBAAY,iBAAiB,EAAE;EAC/B,wBAAe,cAAc,EAAE,2BAA2B,EAAE;EAC5D,wBAAa,eAAe,EAAE,cAAc,EAAE;AAChD","sourcesContent":["/* ─────────────────────────────────────────────────────────────\n   Shared 3-column browse layout, used by every browse page: the Node, Data,\n   Agent, Discovery and Model Catalogs, and the project list (which imports the\n   rail, header band and drawer from here and adds only its own card styles in\n   pages/projects/ProjectsBrowseLayout.module.css). The rail is CatalogRail.tsx\n   and the header band CatalogPageHeader.tsx, so the pages cannot drift apart.\n\n   Colours, type and geometry come from ../../styles/curioTokens.css. Format\n   and category colours in particular are tokens, not literals: they are shown\n   on six other surfaces and used to be copied into each of them.\n   Page shell lives in CatalogMasterPage.module.css.\n   ───────────────────────────────────────────────────────────── */\n\n/* ── 3-column browse layout ── */\n.page {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 188px minmax(0, 1fr) 0px;\n  grid-template-rows: minmax(0, 1fr);\n  /* Shared browse cards (every browse page; inherited by nested cards). A card\n     is as tall as its content and a row as tall as its tallest card: the old\n     268px floor left a band of blank card under every short description. */\n  --catalogBrowseCardMinWidth: 220px;\n  --catalogBrowseCardGridGap: 16px;\n  --catalogBrowseCardGridPadding: 16px;\n  --catalogBrowseCardBodyPadX: 16px;\n  --catalogBrowseCardBodyPadBottom: 8px;\n  --catalogBrowseCardDescLineHeight: 1.4;\n  --catalogBrowseCardDescLines: 2;\n  --catalogBrowseCardActionsMinH: 44px;\n  --catalogBrowseCardActionsPadY: 8px;\n  --catalogBrowseCardMetaPadTop: 10px;\n  --catalogBrowseCardTagGap: 5px;\n  /* Card grid scrollbar (Data + Nodes tabs) */\n  --catalogBrowseCardGridScrollbarThumb: rgba(30, 31, 35, 0.22);\n  --catalogBrowseCardGridScrollbarThumbHover: rgba(30, 31, 35, 0.35);\n  --catalogBrowseCardGridScrollbarTrack: rgba(30, 31, 35, 0.06);\n}\n\n.pageWithDrawer {\n  grid-template-columns: 188px minmax(0, 1fr) 320px;\n}\n\n.detailPage {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ══════════════════════════════════════════\n   LEFT CATEGORY RAIL\n   ══════════════════════════════════════════ */\n.categoryRail {\n  grid-column: 1;\n  grid-row: 1;\n  background: var(--curio-card-bg);\n  border-right: 1px solid var(--curio-border);\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0 16px;\n  overflow-y: auto;\n}\n\n/* Nothing in the rail may shrink. It is a flex column that scrolls, so when it\n   is taller than the window the browser shrinks every child that allows it,\n   and an empty 1px divider allows it down to nothing: the section lines showed\n   on a rail that fit (Node, Agent, Data Lake) and vanished on one that did not\n   (Data, Projects). */\n.categoryRail > * {\n  flex-shrink: 0;\n}\n\n.railLabel {\n  margin: 10px 0 4px;\n  padding: 0 16px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #BBBBBB;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.railButton {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  border: 0;\n  background: transparent;\n  color: var(--curio-text-secondary);\n  padding: 6px 16px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 400;\n  cursor: pointer;\n  text-align: left;\n  min-height: 30px;\n}\n\n/* Hover feedback is for rows you have NOT chosen: the selected row already\n   announces itself with its fill, its weight and its bar. */\n.railButton:hover:not(.railButtonActive) { background: rgba(0,0,0,0.02); }\n\n.railButtonActive {\n  background: var(--curio-page-bg);\n  color: var(--curio-text-primary);\n  font-weight: 700;\n}\n\n.railButtonActive::before {\n  content: \"\";\n  position: absolute;\n  left: 0; top: 0; bottom: 0;\n  width: 4px;\n  background: var(--curio-top-bar-bg);\n  border-radius: 0 2px 2px 0;\n}\n\n.railCountBadge {\n  min-width: 28px;\n  height: 18px;\n  border-radius: 9px;\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  font-size: 10px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  flex-shrink: 0;\n}\n\n.railCount {\n  color: var(--curio-text-meta);\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n.railFormatItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.dot_geojson { background: var(--curio-format-geojson-fg); }\n.dot_csv { background: var(--curio-format-csv-fg); }\n.dot_json { background: var(--curio-format-json-fg); }\n.dot_parquet { background: var(--curio-format-parquet-fg); }\n.dot_geotiff { background: var(--curio-format-geotiff-fg); }\n.dot_shp { background: var(--curio-format-shp-fg); }\n.dot_bundle { background: var(--curio-format-bundle-fg); }\n.dot_osm { background: var(--curio-format-osm-fg); }\n.dot_gpkg { background: var(--curio-format-gpkg-fg); }\n.dot_gtfs { background: var(--curio-format-gtfs-fg); }\n.dot_collection { background: var(--curio-format-collection-fg); }\n.dot_onnx { background: var(--curio-format-onnx-fg); }\n.dot_netcdf { background: var(--curio-format-netcdf-fg); }\n\n/* Node Catalog category rows: the same keys and colours as the package card\n   strips (`primaryCategory()`: data | computation | vis | package). */\n.categoryDot_data        { background: var(--curio-category-data-fg); }\n.categoryDot_computation { background: var(--curio-category-computation-fg); }\n.categoryDot_vis         { background: var(--curio-category-vis-fg); }\n.categoryDot_package     { background: var(--curio-category-package-fg); }\n\n/* Agent Catalog category rows: the agent card strips' palette keys\n   (`agentCategoryKey()`), not the node categories. */\n.agentDot_node     { background: var(--curio-category-agent-node-fg); }\n.agentDot_canvas   { background: var(--curio-category-agent-canvas-fg); }\n.agentDot_data     { background: var(--curio-category-agent-data-fg); }\n.agentDot_evaluate { background: var(--curio-category-agent-evaluate-fg); }\n.agentDot_package  { background: var(--curio-category-agent-package-fg); }\n\n.railDivider {\n  height: 1px;\n  margin: 10px 16px 0;\n  background: #EBEBEB;\n}\n\n/* ══════════════════════════════════════════\n   MAIN BROWSE AREA\n   ══════════════════════════════════════════ */\n/* The header stays put and the card grid owns the scroll, so the grid takes\n   exactly the height the header leaves. It used to be sized as\n   `calc(100vh - 290px)`, a guess at the header that was wrong as soon as an\n   intro wrapped, and then the whole column scrolled as well. */\n.browseMain {\n  grid-column: 2;\n  grid-row: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* ── Page header (white): one row, then a one-line intro ── */\n.browseHeader {\n  background: var(--curio-card-bg);\n  padding: 12px 20px 10px;\n  border-bottom: 1px solid var(--curio-border);\n  flex-shrink: 0;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 10px;\n}\n\n.titleRow h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--curio-text-primary);\n}\n\n.titleCount {\n  min-width: 34px;\n  height: 22px;\n  border-radius: 11px;\n  background: #E8E8E5;\n  color: #777777;\n  font-size: 11px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n}\n\n/* The second header row: the intro, then sort (and Projects' grid or list\n   switch) at its end, right above the cards they arrange. Sort sat in the chip\n   row before; it moved here rather than into the title row, where the Projects\n   page's three actions left it no room. */\n.introRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 6px;\n}\n\n/* Page description under the title row. Was an inline style duplicated\n   verbatim in NodeCatalogBrowse and DataCatalogBrowse. */\n.pageIntro {\n  flex: 1 1 auto;\n  min-width: 0;\n  margin: 0;\n  font-size: var(--curio-font-size-sm);\n  line-height: 1.4;\n  color: var(--curio-text-secondary);\n}\n\n.viewTools {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n/* Search and the page's actions, at the end of the title row. It takes all\n   the width the title leaves and never wraps: the search box gives up width\n   instead, so the buttons stay on the title's line. */\n.headerTools {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n  gap: 8px;\n}\n\n.hubSearch {\n  flex: 0 1 240px;\n  min-width: 120px;\n  max-width: 300px;\n  height: 34px;\n  border: 1px solid var(--curio-border);\n  border-radius: 9px;\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  padding: 0 12px;\n  font-family: inherit;\n  font-size: 12px;\n}\n\n.hubSearch::placeholder { color: #CCCCCC; }\n.hubSearch:focus { outline: none; border-color: #AAAAAA; }\n\n.publishButton {\n  height: 34px;\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  background: transparent;\n  color: var(--curio-text-primary);\n  padding: 0 14px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.publishButton:hover { background: #f5f5f5; }\n\n.primaryHeaderButton {\n  height: 34px;\n  border: 0;\n  border-radius: var(--curio-radius-lg);\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  padding: 0 16px;\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.primaryHeaderButton:hover { background: var(--curio-top-bar-bg-hover); }\n\n/* ── Search bar ──\n   Only the Data Lake source page has one now, above its results. The browse\n   pages had a chip row here that repeated the rail beside it: the same \"All\",\n   the same \"In all projects\", the same formats and categories. It cost every\n   page 49 to 84px above the cards and is gone; its sort control lives in the\n   header row. */\n.filterBar {\n  background: #FAFAFA;\n  border-bottom: 1px solid #E8E8E8;\n  padding: 11px 24px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.filterSpacer { flex: 1; }\n\n/* Bordered like the search box above it, a step lower so the intro row it\n   shares stays one line of text tall. */\n.sortSelect {\n  height: 28px;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-lg);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-secondary);\n  padding: 0 8px;\n  font-family: inherit;\n  font-size: 12px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n/* ── Card grid ──\n   As many columns as fit, from the width the grid actually has: with the\n   details drawer open at 1280px that is three, with it closed four. It was\n   three fixed columns that fell to two below a 1300px VIEWPORT, whatever the\n   rail and the drawer left of it. */\n.cardGrid {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(var(--catalogBrowseCardMinWidth, 220px), 1fr));\n  /* A row is as tall as its tallest card, never less. The cards clip their\n     overflow, which gives them no automatic minimum height, so in a grid of\n     fixed height (this one scrolls) `auto` rows would share that height out\n     and crush every card to a strip and half a title. */\n  grid-auto-rows: max-content;\n  gap: var(--catalogBrowseCardGridGap, 16px);\n  padding: var(--catalogBrowseCardGridPadding, 16px);\n  /* Pack rows to the top so a short filtered list does not stretch rows to fill the viewport */\n  align-content: start;\n  align-items: stretch;\n  box-sizing: border-box;\n  scrollbar-gutter: stable;\n  scrollbar-width: thin;\n  scrollbar-color: var(--catalogBrowseCardGridScrollbarThumb, rgba(30, 31, 35, 0.22))\n    var(--catalogBrowseCardGridScrollbarTrack, rgba(30, 31, 35, 0.06));\n}\n\n.cardGridRefreshing {\n  opacity: 0.72;\n  pointer-events: none;\n  transition: opacity 0.18s ease-out;\n}\n\n.cardGrid::-webkit-scrollbar {\n  width: 6px;\n}\n\n.cardGrid::-webkit-scrollbar-track {\n  background: var(--catalogBrowseCardGridScrollbarTrack, rgba(30, 31, 35, 0.06));\n  border-radius: 3px;\n  margin: 4px 0;\n}\n\n.cardGrid::-webkit-scrollbar-thumb {\n  background: var(--catalogBrowseCardGridScrollbarThumb, rgba(30, 31, 35, 0.22));\n  border-radius: 3px;\n  border: 1px solid transparent;\n  background-clip: padding-box;\n}\n\n.cardGrid::-webkit-scrollbar-thumb:hover {\n  background: var(--catalogBrowseCardGridScrollbarThumbHover, rgba(30, 31, 35, 0.35));\n  background-clip: padding-box;\n}\n\n.empty, .error {\n  margin: 24px;\n  border: 1px dashed #d4d3cd;\n  border-radius: 8px;\n  color: var(--curio-text-meta);\n  padding: 32px 16px;\n  text-align: center;\n  font-size: 13px;\n}\n\n.error {\n  color: var(--curio-danger-text);\n  background: var(--curio-danger-bg);\n  border-color: var(--curio-danger-border);\n}\n\n/* ══════════════════════════════════════════\n   BROWSE CARD\n   ══════════════════════════════════════════ */\n.card {\n  display: flex;\n  flex-direction: column;\n  border: 1.5px solid transparent;\n  border-radius: 10px;\n  background: var(--curio-card-bg);\n  box-shadow: var(--curio-shadow-browse-card);\n  overflow: hidden;\n  cursor: pointer;\n  outline: none;\n  transition: box-shadow 0.15s, border-color 0.15s;\n  box-sizing: border-box;\n  height: auto;\n  align-self: stretch;\n}\n\n.card:hover, .card:focus-visible {\n  box-shadow: var(--curio-shadow-browse-card-raised);\n}\n\n.cardActive { box-shadow: var(--curio-shadow-browse-card-raised); }\n\n/* Colored top strip */\n.cardStrip {\n  min-height: 28px;\n  display: flex;\n  align-items: center;\n  padding: 3px 12px;\n  flex-shrink: 0;\n}\n\n.strip_geojson { background: var(--curio-format-geojson-fg); }\n.strip_csv { background: var(--curio-format-csv-fg); }\n.strip_json { background: var(--curio-format-json-fg); }\n.strip_parquet { background: var(--curio-format-parquet-fg); }\n.strip_geotiff { background: var(--curio-format-geotiff-fg); }\n.strip_shp { background: var(--curio-format-shp-fg); }\n.strip_bundle { background: var(--curio-format-bundle-fg); }\n.strip_osm { background: var(--curio-format-osm-fg); }\n.strip_gpkg { background: var(--curio-format-gpkg-fg); }\n.strip_gtfs { background: var(--curio-format-gtfs-fg); }\n.strip_collection { background: var(--curio-format-collection-fg); }\n.strip_onnx { background: var(--curio-format-onnx-fg); }\n.strip_netcdf { background: var(--curio-format-netcdf-fg); }\n\n/* Active card: colored border matches strip */\n.cardActive.card_geojson { border-color: var(--curio-format-geojson-fg); }\n.cardActive.card_csv { border-color: var(--curio-format-csv-fg); }\n.cardActive.card_json { border-color: var(--curio-format-json-fg); }\n.cardActive.card_parquet { border-color: var(--curio-format-parquet-fg); }\n.cardActive.card_geotiff { border-color: var(--curio-format-geotiff-fg); }\n.cardActive.card_shp { border-color: var(--curio-format-shp-fg); }\n.cardActive.card_bundle { border-color: var(--curio-format-bundle-fg); }\n.cardActive.card_osm { border-color: var(--curio-format-osm-fg); }\n.cardActive.card_gpkg { border-color: var(--curio-format-gpkg-fg); }\n.cardActive.card_gtfs { border-color: var(--curio-format-gtfs-fg); }\n.cardActive.card_collection { border-color: var(--curio-format-collection-fg); }\n.cardActive.card_onnx { border-color: var(--curio-format-onnx-fg); }\n.cardActive.card_netcdf { border-color: var(--curio-format-netcdf-fg); }\n\n.cardFormatBadge {\n  height: 16px;\n  border-radius: 8px;\n  background: rgba(255,255,255,0.22);\n  color: var(--curio-text-on-dark);\n  padding: 0 8px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  display: inline-flex;\n  align-items: center;\n}\n\n.stripBadgePopular {\n  height: 16px;\n  border-radius: 8px;\n  background: rgba(255,255,255,0.22);\n  color: var(--curio-text-on-dark);\n  padding: 0 8px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* Card body */\n.cardBody {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  padding: 0 var(--catalogBrowseCardBodyPadX, 16px) var(--catalogBrowseCardBodyPadBottom, 8px);\n}\n\n.cardTitle {\n  margin: 10px 0 2px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--curio-text-primary);\n  line-height: 1.3;\n}\n\n.publisher {\n  margin: 0;\n  font-size: 11px;\n  color: var(--curio-text-meta);\n}\n\n.cardDescription {\n  margin: 8px 0 0;\n  font-size: 13px;\n  color: var(--curio-text-primary);\n  line-height: var(--catalogBrowseCardDescLineHeight, 1.4);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: calc(var(--catalogBrowseCardDescLines, 2) * var(--catalogBrowseCardDescLineHeight, 1.4) * 1em);\n  flex-shrink: 0;\n}\n\n.tagRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--catalogBrowseCardTagGap, 5px);\n  margin: 0;\n  margin-top: auto;\n  padding-top: 10px;\n  min-height: 22px;\n  align-content: flex-end;\n}\n\n.tag {\n  height: 16px;\n  border-radius: 8px;\n  background: var(--curio-page-bg);\n  color: var(--curio-text-secondary);\n  padding: 0 7px;\n  font-size: 9px;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* Meta row */\n.cardMeta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  margin: 0;\n  margin-top: 4px;\n  padding: var(--catalogBrowseCardMetaPadTop, 10px) var(--catalogBrowseCardBodyPadX, 16px) 0;\n  border-top: 1px solid var(--curio-page-bg);\n  font-size: 10px;\n  color: var(--curio-text-meta);\n  flex-shrink: 0;\n}\n\n.metaLeft {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.metaRight {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-shrink: 0;\n  font-size: 11px;\n}\n\n.liveDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.liveDotGreen { background: var(--curio-role-installed-fg); }\n.liveDotGray  { background: var(--curio-text-muted); }\n\n/* Actions row */\n.cardActions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 0;\n  min-height: var(--catalogBrowseCardActionsMinH, 44px);\n  padding: var(--catalogBrowseCardActionsPadY, 8px) var(--catalogBrowseCardBodyPadX, 16px) 10px;\n  border-top: 1px solid var(--curio-page-bg);\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.cardActionsLeft {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n/* A card's state (\"In all projects\", \"Link only\"), at the start of its\n   actions row: the strip says what the item is, this says where it stands,\n   the link beside it says what you can do. It rode at the end of the strip\n   until the cards narrowed, where it ran over the format or category pill. */\n.cardStatus {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--curio-role-installed-fg);\n  white-space: nowrap;\n}\n\n.cardStatusMuted {\n  color: var(--curio-text-meta);\n}\n\n.cardActionsRight {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.linkButton {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--curio-text-primary);\n  cursor: pointer;\n}\n\n.linkButton:hover {\n  text-decoration: underline;\n}\n\n/* A drawer CTA that is neither an action nor a destructive one.\n *\n * The catalogs run a strict two-colour vocabulary: dark filled = action, light\n * bordered = destructive. \"View details\" is neither - it navigates - so giving\n * it either treatment would say something false about it. It keeps the CTA\n * stack's 42px height so the column does not go ragged, and reads as the link\n * it is. Same role as `.linkButton` on the cards, sized for the drawer.\n */\n.drawerLinkButton {\n  width: 100%;\n  height: 42px;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--curio-text-primary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.drawerLinkButton:hover {\n  text-decoration: underline;\n}\n\n/* ══════════════════════════════════════════\n   RIGHT DETAIL DRAWER\n   ══════════════════════════════════════════ */\n/* Grid cell that clips the sliding drawer as the column expands / collapses. */\n.browseDrawerColumn {\n  grid-column: 3;\n  grid-row: 1;\n  min-width: 0;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Entire drawer panel — appears and disappears with its column, no motion. */\n.browseDrawer {\n  width: 320px;\n  height: 100%;\n  background: var(--curio-card-bg);\n  border-left: 1px solid var(--curio-border);\n  box-shadow: -4px 0 10px rgba(0,0,0,0.09);\n  display: flex;\n  flex-direction: column;\n  /* The body scrolls, not the drawer: the header and the action row stay\n     where they are (#526). */\n  overflow: hidden;\n}\n\n.drawerBody {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.drawerHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 50px;\n  background: #FAFAFA;\n  border-bottom: 1px solid #EBEBEB;\n  padding: 0 20px;\n  flex-shrink: 0;\n}\n\n/* Dismissible banner above the card grid: an action error, or a summary of\n   what an install just did. NodeCatalogBrowse still writes this with inline\n   styles - two of them, in two hardcoded colour pairs - which is exactly the\n   drift the token palette exists to end. Declared here so every browse page\n   can share one, and so the colours come from tokens. */\n.browseBanner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin: 12px 24px 0;\n    padding: 10px 14px;\n    border: 1px solid var(--curio-danger-border);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-danger-bg);\n    color: var(--curio-danger-text);\n    font-family: var(--curio-font-family);\n    font-size: var(--curio-font-size-md);\n}\n\n.browseBannerDismiss {\n    flex-shrink: 0;\n    background: none;\n    border: none;\n    color: inherit;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0 4px;\n}\n\n.drawerKindHero {\n  margin: 16px 20px 0;\n  height: 112px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f6f8;\n  flex-shrink: 0;\n}\n\n.drawerClose {\n  width: 24px;\n  height: 24px;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  color: #AAAAAA;\n  font-size: 18px;\n  line-height: 1;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Geo preview */\n.geoPreview {\n  margin: 16px 20px 0;\n  height: 112px;\n  border-radius: 8px;\n  background: #F0FAF2;\n  flex-shrink: 0;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.geoPreviewSvg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.geoPreviewStatus {\n  position: relative;\n  z-index: 1;\n  font-size: 10px;\n  color: #666666;\n  padding: 0 12px 8px;\n  text-align: center;\n}\n\n.drawerPreviewTableWrap {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.94);\n  padding: 6px 8px;\n  box-sizing: border-box;\n}\n\n.drawerPreviewTable {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 9px;\n  line-height: 1.25;\n}\n\n.drawerPreviewTable th,\n.drawerPreviewTable td {\n  padding: 2px 4px;\n  border-bottom: 1px solid #ebebeb;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left;\n}\n\n.drawerPreviewTable th {\n  color: var(--curio-text-meta);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.drawerPreviewTable td {\n  color: #333333;\n}\n\n/* Dataset name */\n.drawerDatasetName {\n  padding: 14px 20px 0;\n  flex-shrink: 0;\n}\n\n.drawerDatasetName h2 {\n  margin: 0 0 10px;\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--curio-text-primary);\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.drawerBadgesRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.drawerFormatBadge {\n  height: 20px;\n  border-radius: 10px;\n  padding: 0 10px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  display: inline-flex;\n  align-items: center;\n}\n\n.dfmt_geojson { background: var(--curio-format-geojson-bg); color: var(--curio-format-geojson-on-tint); }\n.dfmt_csv { background: var(--curio-format-csv-bg); color: var(--curio-format-csv-on-tint); }\n.dfmt_json { background: var(--curio-format-json-bg); color: var(--curio-format-json-on-tint); }\n.dfmt_parquet { background: var(--curio-format-parquet-bg); color: var(--curio-format-parquet-on-tint); }\n.dfmt_geotiff { background: var(--curio-format-geotiff-bg); color: var(--curio-format-geotiff-on-tint); }\n.dfmt_shp { background: var(--curio-format-shp-bg); color: var(--curio-format-shp-on-tint); }\n.dfmt_bundle { background: var(--curio-format-bundle-bg); color: var(--curio-format-bundle-on-tint); }\n.dfmt_osm { background: var(--curio-format-osm-bg); color: var(--curio-format-osm-on-tint); }\n.dfmt_gpkg { background: var(--curio-format-gpkg-bg); color: var(--curio-format-gpkg-on-tint); }\n.dfmt_gtfs { background: var(--curio-format-gtfs-bg); color: var(--curio-format-gtfs-on-tint); }\n.dfmt_collection { background: var(--curio-format-collection-bg); color: var(--curio-format-collection-on-tint); }\n.dfmt_onnx { background: var(--curio-format-onnx-bg); color: var(--curio-format-onnx-on-tint); }\n.dfmt_netcdf { background: var(--curio-format-netcdf-bg); color: var(--curio-format-netcdf-on-tint); }\n\n.drawerInstalledBadge {\n  height: 20px;\n  border-radius: 10px;\n  background: var(--curio-role-installed-bg);\n  color: var(--curio-role-installed-fg);\n  padding: 0 10px;\n  font-size: 10px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Package category pill. Distinct from .drawerFormatBadge: a category is not a\n   file format, so it must not borrow a dfmt_* colour (the package drawer used to\n   render its category in the parquet orange). */\n.drawerCategoryBadge {\n  height: 20px;\n  border-radius: 10px;\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-primary);\n  padding: 0 10px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* Publisher row */\n.drawerPublisher {\n  padding: 0 20px 6px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.drawerPublisherText {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--curio-text-secondary);\n}\n\n/* Usage meta */\n.drawerMeta {\n  padding: 0 20px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 11px;\n  color: var(--curio-text-meta);\n  margin-bottom: 0;\n  flex-shrink: 0;\n}\n\n.drawerMetaRight {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-shrink: 0;\n}\n\n/* Section blocks */\n.drawerSection {\n  border-top: 1px solid #F2F2F2;\n  padding: 12px 20px;\n  flex-shrink: 0;\n}\n\n.drawerSectionLabel {\n  margin: 0 0 10px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #BBBBBB;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.drawerDescription {\n  margin: 0;\n  font-size: 13px;\n  color: var(--curio-text-primary);\n  line-height: 1.5;\n}\n\n/* Info table rows */\n.infoRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 26px;\n  border-bottom: 1px solid #F8F8F8;\n  font-size: 11px;\n}\n\n.infoRow:last-child { border-bottom: 0; }\n\n.infoRowLabel {\n  color: var(--curio-text-primary);\n  font-weight: 600;\n}\n\n.infoRowValue {\n  color: var(--curio-text-meta);\n}\n\n/* Bulleted list inside a drawer section (e.g. \"Nodes in pack\"). */\n.drawerList {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 12px;\n  color: var(--curio-text-secondary);\n}\n\n.drawerListMore {\n  color: var(--curio-text-muted);\n}\n\n/* Tags in drawer */\n.drawerTagsRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.drawerTag {\n  height: 20px;\n  border-radius: 10px;\n  background: var(--curio-page-bg);\n  color: var(--curio-text-secondary);\n  padding: 0 10px;\n  font-size: 10px;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* CTA section */\n.drawerCtas {\n  border-top: 1px solid #EBEBEB;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.addToPaletteBtn {\n  width: 100%;\n  height: 42px;\n  border: 0;\n  border-radius: 8px;\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.addToPaletteBtn:hover { background: var(--curio-top-bar-bg-hover); }\n\n/* The destructive twin of `.addToPaletteBtn`, same box so the panel does not\n * reflow when a card swaps one for the other.\n *\n * One vocabulary across every catalog surface: dark is an action, light with a\n * border is destructive. The Agent browse drawer used `.addToPaletteBtn` for\n * BOTH \"Add to my account\" and \"Remove from my account\", so the two opposite\n * actions were the same black button in the same place, and the destructive one\n * carried the visual weight of the primary. */\n.destructiveBtn {\n  width: 100%;\n  height: 42px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: 8px;\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.destructiveBtn:hover:not(:disabled) {\n  border-color: #888787;\n  background: var(--curio-page-bg);\n}\n\n.destructiveBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.drawerPillRow {\n  display: flex;\n  justify-content: center;\n}\n\n/* A centred note standing in for the primary action, when there is no action\n   left to offer - a package already in your defaults, a portal that cannot be\n   searched. Shared because both of those pages wanted it and one of them was\n   reaching for an inline `textAlign: center` to get it. */\n.drawerNote {\n  margin: 0;\n  text-align: center;\n  font-size: var(--curio-font-size-md);\n  color: var(--curio-text-secondary);\n  line-height: 1.5;\n}\n\n/* ══════════════════════════════════════════\n   RESPONSIVE\n   ══════════════════════════════════════════ */\n/* No column counts here: the grid's auto-fill already follows the width it\n   has. These only move the drawer and the rail out of the way. */\n@media (max-width: 1100px) {\n  .page { grid-template-columns: 188px minmax(0, 1fr); }\n  .browseDrawerColumn { display: none; }\n  .headerTools { flex-wrap: wrap; }\n}\n\n/* One column of everything, and the page scrolls as a whole: the rail sits\n   above the header, so neither region has a height of its own to scroll in. */\n@media (max-width: 820px) {\n  .page { display: block; overflow-y: auto; }\n  .categoryRail { border-right: 0; border-bottom: 1px solid var(--curio-border); }\n  .browseMain { overflow: visible; }\n  .cardGrid { overflow: visible; }\n  .headerTools { flex: 1 1 100%; justify-content: flex-start; }\n  .hubSearch { max-width: none; flex: 1 1 100%; }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `VfrM6ibRZBlZ6gUG_Wk7`,
	"pageWithDrawer": `nWJscCJ5p2UtOWtglln8`,
	"detailPage": `L5BFXgCV9YdcpwokRYr7`,
	"categoryRail": `RpSSE68p5ogT1pcKgl0g`,
	"railLabel": `X1gaB7xlXqlJvrKuJjp5`,
	"railButton": `nP9_T2b2FS7Sg1egdH8d`,
	"railButtonActive": `AGy3WwvOXcyra3GV1JMn`,
	"railCountBadge": `VEVFUiIp0CTRM9tcM6eJ`,
	"railCount": `mFyhwipkL21eRHE7xUwr`,
	"railFormatItem": `mrN8fFdwyYFU3HWu89a0`,
	"dot": `DBJUfSDi3zJ9Qmf_n4f2`,
	"dot_geojson": `HQ3Imb8B5kCA9DgR545b`,
	"dot_csv": `btLh58XW1qCPndVY2ovY`,
	"dot_json": `JzyXx9YNRhK1_Bv261nT`,
	"dot_parquet": `JYZEu5i5KYcIouThIXPS`,
	"dot_geotiff": `GUneDuGobBmHON6sBuaG`,
	"dot_shp": `xzonQ5DqNRSjLlK2ND8Q`,
	"dot_bundle": `iBM1KWgO5udPBt6Jo1uv`,
	"dot_osm": `O2L8ryJP41XbuoWu4gTw`,
	"dot_gpkg": `OeGz2VCUghGArMW6UJea`,
	"dot_gtfs": `cCRK06v6zAzCEYV0SLAw`,
	"dot_collection": `jVuT8ZjNUhucdJPaHgOd`,
	"dot_onnx": `IIQV7kICx9k0nGhGx26G`,
	"dot_netcdf": `gJFa9MXu1IaVD4wFHM4H`,
	"categoryDot_data": `QkqENvOMgp7hc9SaPPbM`,
	"categoryDot_computation": `Igvz2umcHE_cRcKVf2Mq`,
	"categoryDot_vis": `NcQLlzXiG7W9tTGCljnb`,
	"categoryDot_package": `wkGnUazAVtm3myMrGcpG`,
	"agentDot_node": `YogVuZXZMhOY7ALQVyR3`,
	"agentDot_canvas": `r7THFCjoOTTSCb5jdory`,
	"agentDot_data": `l7byw8ovwwChEh0QoWLb`,
	"agentDot_evaluate": `eqXcqnuiKJcWIH379mp9`,
	"agentDot_package": `eACMCYfS1vAA_qVNwPFN`,
	"railDivider": `l26vAdNzKqlzonq6bO1C`,
	"browseMain": `_m6dG9gLZ0nF9aODfwWu`,
	"browseHeader": `IUsCLvHaiNyCRZeB26Io`,
	"titleRow": `wRpK9B2nL0BgYHrEWHvI`,
	"titleCount": `ktMrB9OfRJpyTlKCOzJy`,
	"introRow": `lqgq1gOBYDuHw6ts9hNs`,
	"pageIntro": `KQ18_kh6q4rJHMZr4Fh4`,
	"viewTools": `SaZcifbeP1OADRCRp0zV`,
	"headerTools": `LEmprhZKDr0RbmzV4Y4L`,
	"hubSearch": `_MnkjfhCufoYt1a7nngw`,
	"publishButton": `JsRq91dug7VMxP8bFMO8`,
	"primaryHeaderButton": `DOoCTCnNbZPY8Lgcbaa_`,
	"filterBar": `HQZx0WKGk9aNKS2rCKpJ`,
	"filterSpacer": `DJPfPFYq7OyezuoSbeY2`,
	"sortSelect": `Od_5CuSCyh5eEKYUL4fN`,
	"cardGrid": `fpRBOzsRnwrxKWXjMFdP`,
	"cardGridRefreshing": `jCLYRVsTDVwGLVOBlvVf`,
	"empty": `heWl2fugj3DzhjzWyNRf`,
	"error": `y8im69drSGaobhllQ895`,
	"card": `Ea9RFRvFcbDKactM5lkt`,
	"cardActive": `kCuH8CQkfSW9gXLWxhpw`,
	"cardStrip": `Oyt7UMsROFaVYI9VPHBf`,
	"strip_geojson": `C80pwmK47C2xvCPw_m53`,
	"strip_csv": `wSl0TR_J46q2BQcJbbdw`,
	"strip_json": `XfKxAyIiENuLxUnBOgpr`,
	"strip_parquet": `qneyw4mvDLnP2BmO4tM6`,
	"strip_geotiff": `quLmk_YNj2mI7pI80yjI`,
	"strip_shp": `wA1qF13_Of68phDsUmRA`,
	"strip_bundle": `jDiM_vjXEcHRBVHr0MQN`,
	"strip_osm": `FnfWTXsNV_24MnmPsKJi`,
	"strip_gpkg": `cp6x1w8eusHmJbcMwwgr`,
	"strip_gtfs": `j4rjCmNJnYJUJVAvQ8AP`,
	"strip_collection": `pka4q2YQo_ymKNks3vt_`,
	"strip_onnx": `irdO111llFcptmniJVbg`,
	"strip_netcdf": `zCKkKH2PNMaggCe66HxW`,
	"card_geojson": `u6V2C3nrzhUeU7thtAmW`,
	"card_csv": `oBQoWjgFZEzBIkfC6BV2`,
	"card_json": `ppTeP0YXzYojAHBi_spx`,
	"card_parquet": `AyxStruIbyNkyilqFHAv`,
	"card_geotiff": `bOxQR9KCCz3DecduXZHV`,
	"card_shp": `L7pl144ncELLiafzUfOB`,
	"card_bundle": `eAc5Es49mUImW9VuwbgY`,
	"card_osm": `xylyk_B9dSDNKfXUcwWt`,
	"card_gpkg": `zsDyFMQRPkt9yoPiwnGE`,
	"card_gtfs": `RCWdbUXjTOZUWL0eH25y`,
	"card_collection": `_8QkDYruqlnHGDmZ5LpD`,
	"card_onnx": `UYOLRIBFsDcCNnb_dzOa`,
	"card_netcdf": `VKQYxN8g3fp0mXzogoS7`,
	"cardFormatBadge": `i21Tmvmsm6NrSB8p1Xq5`,
	"stripBadgePopular": `UwqrsEueCeHwvHLFDped`,
	"cardBody": `HiGL2UaWpfWgbILZoGsP`,
	"cardTitle": `g0SyRaaABSoynYeHBV1w`,
	"publisher": `iCiyQIr00Nx2MpMzsif8`,
	"cardDescription": `ZI_RVyVfqVoobMHdLwfc`,
	"tagRow": `bsGpXtnYtJvag8qSQvDk`,
	"tag": `YEpMi4BN6Fs0v9KImgt2`,
	"cardMeta": `gWuUm7jra6fYsT8NVmWD`,
	"metaLeft": `QwsmAXVqGTmlj4KLSeHc`,
	"metaRight": `VEoANzs40k0cUUD1G_yZ`,
	"liveDot": `uVCBcIpS7SwSRd9oui9u`,
	"liveDotGreen": `Eksaf8kloYVG6HTtCr7w`,
	"liveDotGray": `lWqXFU0tN3FlHvf5TwhY`,
	"cardActions": `EcJpkKqEkAF7Y6jqGBon`,
	"cardActionsLeft": `EfEOld4D0B6ONZiYbOX4`,
	"cardStatus": `cxRf8OFnyHqkRd11tWyh`,
	"cardStatusMuted": `q_mzL6TdHxuauM3jTaAd`,
	"cardActionsRight": `Udy_6MnAqN8dQaRo2bay`,
	"linkButton": `BT9AXwP321l29GBQSXCP`,
	"drawerLinkButton": `LjnSjQTrL34E9Cih80MZ`,
	"browseDrawerColumn": `eD7RmaJ0uK8QbFctDqeT`,
	"browseDrawer": `HRysVvXtLohrQPQNqn4s`,
	"drawerBody": `js4kV40F7vPQXURE8zA_`,
	"drawerHeader": `pmlkfSWrL0UNYPZRa1dw`,
	"browseBanner": `UB9_82UlKA2RTp9gzQ1X`,
	"browseBannerDismiss": `HkcciIErtLIJudh1atK5`,
	"drawerKindHero": `BqG0Y0aEje2A2A9spxLA`,
	"drawerClose": `Z4oTMuV7ll4bKCNwILgN`,
	"geoPreview": `J1upoyYEre9lke7jz3Ug`,
	"geoPreviewSvg": `lPYIDo7yfqERzPDgShZl`,
	"geoPreviewStatus": `eoseNlalhE_VkJ0JQA7T`,
	"drawerPreviewTableWrap": `pWv_QrAWZ_U6jFrKGbND`,
	"drawerPreviewTable": `mLqg67fWPyJBFuXEvWNw`,
	"drawerDatasetName": `NpSy3vgaqYVibH3GbiFh`,
	"drawerBadgesRow": `z8DwWu3kbZg8Pln7Ss_H`,
	"drawerFormatBadge": `DSNEy60md2A0cs0wiWab`,
	"dfmt_geojson": `ERYh1vZy6cU_sE2Y3jmn`,
	"dfmt_csv": `faIAFdoaFfw7CMKlezFf`,
	"dfmt_json": `w63G4ZLcmAu2X1PzF5nl`,
	"dfmt_parquet": `M5vvez9PhKdTj0ZfrGY0`,
	"dfmt_geotiff": `BGRw79y69hgWZtywyyXT`,
	"dfmt_shp": `mOxlOtKiNEaENGlucFxh`,
	"dfmt_bundle": `EBZ_iySwSjYIpjXHQL1A`,
	"dfmt_osm": `rTDWATkJ6eQGQYBsSADG`,
	"dfmt_gpkg": `fH4Edy9K4VreYdlF1rmo`,
	"dfmt_gtfs": `wXTuZ1AG6ditVa9O0AlA`,
	"dfmt_collection": `fvnFq4jLze0Hlb8dRQX6`,
	"dfmt_onnx": `MLwwcI40hYRIppEEeXY6`,
	"dfmt_netcdf": `lHcIlCZg0Xnf_VGYLz5v`,
	"drawerInstalledBadge": `lBjXlfgXiCyqDqSPLdxw`,
	"drawerCategoryBadge": `c8FRRRPBL79WB8t1qCcz`,
	"drawerPublisher": `bwxsqm3wz1XHPX__W5_a`,
	"drawerPublisherText": `NPVYWaNMjWErEd61DJAd`,
	"drawerMeta": `kjPETWEmQJ9qsY0WqkRR`,
	"drawerMetaRight": `jgSQ7fZ7QKzTLPUllAfJ`,
	"drawerSection": `z3ODzfMh06ZMDSW34Kz9`,
	"drawerSectionLabel": `JX_sWW3iIlyjommLo4yr`,
	"drawerDescription": `Sj5U_1RMBn0yf1wObUKF`,
	"infoRow": `JclYPmrHJHtwGYb0bqbJ`,
	"infoRowLabel": `rfz9uAZ_tskHdo0dhwBs`,
	"infoRowValue": `t3T763SxGWHEmgSJO8uY`,
	"drawerList": `Zg1DmXE5Map38Kx8Pv99`,
	"drawerListMore": `pHXpBeB3OJ6oDl_M4aHO`,
	"drawerTagsRow": `gn3JbMteJP5Y_4j0FbcR`,
	"drawerTag": `I2ZgBDYtbP4BxauGthpv`,
	"drawerCtas": `Dm2nkDu8PT9KqFVGDFbT`,
	"addToPaletteBtn": `uQSm8qRDfWccp_QT5sdF`,
	"destructiveBtn": `Vtj51SwFkMB1FGzKAplg`,
	"drawerPillRow": `pUuRE8tStgOUaJJXSmKO`,
	"drawerNote": `oHCrVYWGHuEySWd1ji_R`
};
export default ___CSS_LOADER_EXPORT___;
